var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',{staticClass:"thead-sort",attrs:{"variant":"outline"},on:{"click":_vm.toggle}},[_vm._t("default"),_c('span',{staticClass:"thead-sort__controls"},[_c('span',{class:['fa fa-chevron-up icon', { icon__active: _vm.sorted }]}),_c('span',{class:['fa fa-chevron-down icon', { icon__active: _vm.sortedDesc }]})])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }